module.exports = __webpack_public_path__ + "img/shape_student_accept.51b32ff6.svg";